document.addEventListener("DOMContentLoaded", () => {
  console.log("feature.js loaded");


/*
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
Intro Demo
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  
*/



function initIntroVariableDemo(demo) {
  const svg = demo.querySelector(".intro-variable-svg");
  const plot = demo.querySelector(".intro-variable-plot");
  const letters = [...demo.querySelectorAll(".intro-variable-letter")];
  const word = demo.querySelector(".intro-variable-word");
  const guideLayer = demo.querySelector(".intro-variable-guides");
  const sequenceLetters = [...(demo.dataset.introSequence || "")];
  const isSequentialLetterDemo = sequenceLetters.length > 0 && letters.length === 1;

  if (!svg || !plot || !letters.length || !word || !guideLayer) return null;

  const holdDuration = 1400;
  const transitionDuration = 900;
  const letterSwitchPause = 2000;

  const ranges = {
    wght: [100, 900],
    wdth: [75, 100],
    XHGT: [353, 574]
  };
  const capHeightValue = 746;

  const widthStops = [
    { value: 75, label: "Compressed" },
    { value: 82, label: "Condensed" },
    { value: 90, label: "Narrow" },
    { value: 100, label: "Regular" }
  ];

  const xheightStops = [
    { value: 353, label: "Low" },
    { value: 525, label: "Text" },
    { value: 574, label: "Tall" }
  ];

  const weightStops = [
    { value: 100, label: "Hairline" },
    { value: 300, label: "Light" },
    { value: 350, label: "Book" },
    { value: 400, label: "Regular" },
    { value: 500, label: "Medium" },
    { value: 700, label: "Bold" },
    { value: 800, label: "Extra Bold" },
    { value: 900, label: "Ultra" }
  ];

  const layout = {
    plotY: 455,
    baselineY: 0,
    capHeightY: -395,
    weightValueY: 22,
    xheightValueOffset: -8,
    capHeightValueOffset: 16,
    capHeightLineOffset: 23,
    xheightScale: 0.72,
    widthValueY: -410,
    widthGuideTopY: -405,
    labelY: 58,
    labelLineHeight: 15,
    contentLeft: isSequentialLetterDemo ? -110 : -260,
    contentRightPadding: isSequentialLetterDemo ? 110 : 260
  };
  const initialStates = makeStateSet();
  let sequenceIndex = 0;
  let sequenceChanges = 0;

  if (isSequentialLetterDemo) {
    letters[0].textContent = sequenceLetters[sequenceIndex];
  }

  const states = letters.map((el, i) => {
    const current = initialStates[i];

    return {
      el,
      current,
      from: { ...current },
      target: { ...current }
    };
  });

  // -----------------------------
  // static axes
  // -----------------------------
  const axisX = createSvgEl("line", ["intro-axis-line"]);
  const axisY = createSvgEl("line", ["intro-axis-line"]);
  const capLine = createSvgEl("line", ["intro-axis-line"]);
  const baselineLine = createSvgEl("line", ["intro-baseline-line"]);
  const originLine = createSvgEl("line", ["intro-origin-line"]);

  const widthAxisLabel = createSvgEl("text", ["intro-axis-label"]);
  const capHeightAxisLabel = createSvgEl("text", ["intro-axis-label"]);
  const xheightAxisLabel = createSvgEl("text", ["intro-axis-label", "intro-xheight-axis-label"]);
  const weightAxisLabel = createSvgEl("text", ["intro-axis-label"]);
  guideLayer.appendChild(axisX);
  guideLayer.appendChild(axisY);
  guideLayer.appendChild(capLine);
  guideLayer.appendChild(baselineLine);
  guideLayer.appendChild(originLine);
  guideLayer.appendChild(widthAxisLabel);
  guideLayer.appendChild(capHeightAxisLabel);
  guideLayer.appendChild(xheightAxisLabel);
  guideLayer.appendChild(weightAxisLabel);

  // -----------------------------
  // per-letter guides
  // -----------------------------
  const guides = letters.map((letter, i) => {
    const group = createSvgEl("g");
    const isCapHeightGuide = !isSequentialLetterDemo && i === 0;

    const widthLine = createSvgEl("line", ["intro-guide-line"]);
    const xheightLine = createSvgEl("line", [
      "intro-guide-line",
      isCapHeightGuide ? "intro-capheight-guide" : "intro-xheight-guide"
    ]);

    const widthValue = createSvgEl("text", ["intro-guide-text", "intro-value-text"]);
    const xheightValue = createSvgEl("text", ["intro-guide-text", "intro-value-text"]);
    const weightValue = createSvgEl("text", ["intro-guide-text", "intro-value-text"]);

    const label = createSvgEl("text", ["intro-letter-label"]);
    const labelBox = createSvgEl("rect", ["intro-letter-label-box"]);

    const widthLabel = createSvgEl("tspan", ["intro-label-row"]);
    const xheightLabel = createSvgEl("tspan", ["intro-label-row"]);
    const weightLabel = createSvgEl("tspan", ["intro-label-row"]);

    group.appendChild(widthLine);
    group.appendChild(xheightLine);
    group.appendChild(widthValue);
    group.appendChild(xheightValue);
    group.appendChild(weightValue);
    group.appendChild(labelBox);
    label.appendChild(widthLabel);
    label.appendChild(xheightLabel);
    label.appendChild(weightLabel);
    group.appendChild(label);

    guideLayer.appendChild(group);

    return {
      widthLine,
      xheightLine,
      widthValue,
      xheightValue,
      weightValue,
      labelBox,
      label,
      widthLabel,
      xheightLabel,
      weightLabel,
      isCapHeightGuide
    };
  });

  let phase = "hold";
  let phaseStart = performance.now();
  let isRunning = false;
  let animationFrameId = null;

  function makeStateSet(previousStates = []) {
    const stateProfiles = [
      { wght: [100, 170], wdth: [92, 100], XHGT: [353, 390] },
      { wght: [850, 900], wdth: [82, 90], XHGT: [540, 574] },
      { wght: [420, 680], wdth: [75, 77], XHGT: [420, 500] },
      { wght: [680, 800], wdth: [94, 100], XHGT: [353, 410] },
      { wght: [260, 340], wdth: [81, 83], XHGT: [430, 500] },
      { wght: [430, 560], wdth: [94, 100], XHGT: [520, 574] }
    ];

    const nextStates = [];
    const profiles = stateProfiles.slice(0, letters.length);

    profiles.forEach((profile) => {
      nextStates.push(makeDistinctState(nextStates, profile));
    });

    while (nextStates.length < letters.length) {
      nextStates.push(makeDistinctState(nextStates));
    }

    return orderStatesForContrast(nextStates, previousStates);
  }

  function makeDistinctState(existingStates, profile = ranges) {
    let candidate = makeRandomState(profile);
    let attempts = 0;

    while (!isDistinctState(candidate, existingStates) && attempts < 80) {
      candidate = makeRandomState(profile);
      attempts += 1;
    }

    return candidate;
  }

  function makeRandomState(profile = ranges) {
    return {
      wght: random(...profile.wght),
      wdth: random(...profile.wdth),
      XHGT: random(...profile.XHGT)
    };
  }

  function isDistinctState(candidate, existingStates) {
    return existingStates.every((state) => {
      const wghtDistance = Math.abs(candidate.wght - state.wght);
      const wdthDistance = Math.abs(candidate.wdth - state.wdth);
      const xhgtDistance = Math.abs(candidate.XHGT - state.XHGT);

      if (wghtDistance < 140 && wdthDistance < 7 && xhgtDistance < 60) {
        return false;
      }

      return getStateDistance(candidate, state) > 0.34;
    });
  }

  function getStateDistance(a, b) {
    const wght = (a.wght - b.wght) / (ranges.wght[1] - ranges.wght[0]);
    const wdth = (a.wdth - b.wdth) / (ranges.wdth[1] - ranges.wdth[0]);
    const XHGT = (a.XHGT - b.XHGT) / (ranges.XHGT[1] - ranges.XHGT[0]);

    return Math.sqrt(wght * wght + wdth * wdth + XHGT * XHGT);
  }

  function orderStatesForContrast(nextStates, previousStates = []) {
    let bestOrder = shuffle(nextStates);
    let bestScore = getSequenceContrastScore(bestOrder, previousStates);

    for (let i = 0; i < 220; i += 1) {
      const candidate = shuffle(nextStates);
      const score = getSequenceContrastScore(candidate, previousStates);

      if (score > bestScore) {
        bestOrder = candidate;
        bestScore = score;
      }
    }

    return bestOrder;
  }

  function getSequenceContrastScore(sequence, previousStates = []) {
    const neighborDistances = sequence.slice(1).map((state, i) => {
      return getStateDistance(sequence[i], state);
    });

    const transitionDistances = sequence.map((state, i) => {
      if (!previousStates[i]) return 1;
      return getStateDistance(previousStates[i], state);
    });

    const minNeighborDistance = Math.min(...neighborDistances, 1);
    const minTransitionDistance = Math.min(...transitionDistances);
    const averageNeighborDistance = getAverage(neighborDistances);
    const averageTransitionDistance = getAverage(transitionDistances);
    const weakNeighborCount = neighborDistances.filter((distance) => distance < 0.42).length;
    const weakTransitionCount = transitionDistances.filter((distance) => distance < 0.48).length;

    return (
      minNeighborDistance * 6 +
      minTransitionDistance * 7 +
      averageNeighborDistance +
      averageTransitionDistance -
      weakNeighborCount * 3 -
      weakTransitionCount * 4
    );
  }

  function getAverage(values) {
    if (!values.length) return 0;
    return values.reduce((sum, value) => sum + value, 0) / values.length;
  }

  function applyState(el, state) {
    el.style.fontVariationSettings = getFontVariationSettings(state);
  }

  function getFontVariationSettings(state) {
    return `
      "wght" ${Math.round(state.wght)},
      "wdth" ${Math.round(state.wdth)},
      "XHGT" ${Math.round(state.XHGT)}
    `;
  }

  function getXHeightY(state) {
    return (
      layout.baselineY -
      (state.XHGT / ranges.XHGT[1]) *
        Math.abs(layout.capHeightY) *
        layout.xheightScale
    );
  }

  function syncGuideLabelFontSizes() {
    const labelRowGap = Number.parseFloat(
      getComputedStyle(demo).getPropertyValue("--intro-label-row-gap")
    );
    if (Number.isFinite(labelRowGap) && labelRowGap > 0) {
      layout.labelLineHeight = labelRowGap;
    }

    const viewBoxWidth = svg.viewBox.baseVal.width;
    const renderedWidth = svg.getBoundingClientRect().width;
    if (!viewBoxWidth || !renderedWidth) return;

    const svgScale = renderedWidth / viewBoxWidth;
    const labels = guideLayer.querySelectorAll(
      ".intro-origin-text, .intro-axis-label, .intro-guide-text, .intro-letter-label"
    );

    labels.forEach(label => {
      // Read the breakpoint-specific CSS size first, then translate it into
      // SVG user units so its rendered size stays constant as the viewBox
      // scales with the viewport.
      label.style.removeProperty("font-size");
      const cssFontSize = Number.parseFloat(getComputedStyle(label).fontSize);
      if (Number.isFinite(cssFontSize) && cssFontSize > 0) {
        label.style.fontSize = `${cssFontSize / svgScale}px`;
      }
    });
  }

  function updateGuides() {
    let boxes = [];

    try {
      boxes = states.map((state, i) => {
        // SVG text bounds for individual <tspan>s vary between engines.
        // Character positions come from the parent text run and keep each
        // letter's guides and labels attached to its rendered advance width.
        const start = word.getStartPositionOfChar(i);
        const end = word.getEndPositionOfChar(i);
        const width = end.x - start.x;

        if (Number.isFinite(width) && width > 0) {
          return { x: start.x, width };
        }

        const box = state.el.getBBox();

        if (box.width > 0) return box;

        return word.getExtentOfChar(i);
      });
    } catch {
      return;
    }

    if (!boxes.length) return;

    const lastBox = boxes[boxes.length - 1];
    const wordRight = lastBox.x + lastBox.width;
    const viewBoxWidth = svg.viewBox.baseVal.width || svg.clientWidth;
    const contentLeft = layout.contentLeft;
    const contentRight = wordRight + layout.contentRightPadding;
    const plotX = (viewBoxWidth - (contentRight - contentLeft)) / 2 - contentLeft;
    const svgScale = svg.getBoundingClientRect().width / viewBoxWidth || 1;
    const rootFontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    const letterLabelPaddingX = (rootFontSize * 0.8) / svgScale;
    const letterLabelPaddingY = (rootFontSize * 0.5) / svgScale;

    plot.setAttribute("transform", `translate(${plotX} ${layout.plotY})`);

    // Set the Width label first so the vertical guides can use its actual
    // cap-height edge instead of an approximate y-coordinate.
    widthAxisLabel.setAttribute("x", -6);
    widthAxisLabel.setAttribute("y", layout.capHeightY - 10);
    widthAxisLabel.setAttribute("text-anchor", "end");
    widthAxisLabel.textContent = "Width";

    let widthLabelCapHeightY = layout.widthGuideTopY;
    try {
      widthLabelCapHeightY = widthAxisLabel.getBBox().y;
    } catch {
      // Keep the layout fallback for browsers that cannot measure SVG text.
    }

    // static axes
    axisX.setAttribute("x1", layout.contentLeft);
    axisX.setAttribute("x2", wordRight + layout.contentRightPadding);
    axisX.setAttribute("y1", layout.baselineY);
    axisX.setAttribute("y2", layout.baselineY);

    axisY.setAttribute("x1", 0);
    axisY.setAttribute("x2", 0);
    axisY.setAttribute("y1", widthLabelCapHeightY);
    axisY.setAttribute("y2", layout.labelY + layout.labelLineHeight * 2);

    originLine.setAttribute("x1", 0);
    originLine.setAttribute("x2", 0);
    originLine.setAttribute("y1", widthLabelCapHeightY);
    originLine.setAttribute("y2", layout.labelY + layout.labelLineHeight * 2);

    capLine.setAttribute("x1", 0);
    capLine.setAttribute("x2", wordRight);
    capLine.setAttribute("y1", layout.capHeightY + layout.capHeightLineOffset);
    capLine.setAttribute("y2", layout.capHeightY + layout.capHeightLineOffset);

    baselineLine.setAttribute("x1", 0);
    baselineLine.setAttribute("x2", wordRight);
    baselineLine.setAttribute("y1", layout.baselineY);
    baselineLine.setAttribute("y2", layout.baselineY);

    capHeightAxisLabel.setAttribute("x", -6);
    capHeightAxisLabel.setAttribute("y", layout.capHeightY + layout.capHeightValueOffset);
    capHeightAxisLabel.setAttribute("text-anchor", "end");
    capHeightAxisLabel.textContent = "Cap height";

    xheightAxisLabel.setAttribute("x", -6);
    xheightAxisLabel.setAttribute(
      "y",
      (layout.capHeightY + layout.capHeightValueOffset + layout.weightValueY) / 2
    );
    xheightAxisLabel.setAttribute("text-anchor", "end");
    xheightAxisLabel.textContent = isSequentialLetterDemo && sequenceIndex === 0
      ? ""
      : "x-HEIGHT";

    weightAxisLabel.setAttribute("x", -6);
    weightAxisLabel.setAttribute("y", layout.weightValueY);
    weightAxisLabel.setAttribute("text-anchor", "end");
    weightAxisLabel.textContent = "Weight";

    states.forEach((state, i) => {
      const guide = guides[i];
      const box = boxes[i];
      if (!guide || !box) return;

      const isCapHeightGuide = isSequentialLetterDemo
        ? sequenceIndex === 0
        : guide.isCapHeightGuide;

      guide.xheightLine.classList.toggle("intro-capheight-guide", isCapHeightGuide);
      guide.xheightLine.classList.toggle("intro-xheight-guide", !isCapHeightGuide);

      const left = box.x;
      const right = box.x + box.width;
      const center = box.x + box.width / 2;

      const xheightY = isCapHeightGuide
        ? layout.capHeightY + layout.capHeightLineOffset
        : getXHeightY(state.current);
      const xheightGuideY = isCapHeightGuide ? xheightY : xheightY - 2; //x height guide position

      // 1) vertical line after each letter
      guide.widthLine.setAttribute("x1", right);
      guide.widthLine.setAttribute("x2", right);
      guide.widthLine.setAttribute("y1", widthLabelCapHeightY);
      guide.widthLine.setAttribute("y2", layout.labelY + layout.labelLineHeight * 2);

      // 2) horizontal line on x-height
      guide.xheightLine.setAttribute("x1", left);
      guide.xheightLine.setAttribute("x2", right);
      guide.xheightLine.setAttribute("y1", xheightGuideY);
      guide.xheightLine.setAttribute("y2", xheightGuideY);

      guide.widthValue.setAttribute("x", center);
      guide.widthValue.setAttribute("y", layout.widthValueY);
      guide.widthValue.setAttribute("text-anchor", "middle");
      guide.widthValue.textContent = Math.round(box.width);

      const xheightValueY = isCapHeightGuide
        ? layout.capHeightY + layout.capHeightValueOffset
        : xheightY + layout.xheightValueOffset;

      guide.xheightValue.setAttribute("x", center);
      guide.xheightValue.setAttribute("y", xheightValueY);
      guide.xheightValue.setAttribute("text-anchor", "middle");
      guide.xheightValue.textContent = isCapHeightGuide
        ? capHeightValue
        : Math.round(state.current.XHGT);

      guide.weightValue.setAttribute("x", center);
      guide.weightValue.setAttribute("y", layout.weightValueY);
      guide.weightValue.setAttribute("text-anchor", "middle");
      guide.weightValue.textContent = Math.round(state.current.wght);

      guide.label.setAttribute("x", center);
      guide.label.setAttribute("y", layout.labelY);
      guide.label.setAttribute("text-anchor", "middle");

      guide.widthLabel.setAttribute("x", center);
      guide.widthLabel.setAttribute("dy", 0);
      guide.widthLabel.textContent = getNearestLabel(state.current.wdth, widthStops);

      guide.xheightLabel.setAttribute("x", center);
      guide.xheightLabel.setAttribute("dy", layout.labelLineHeight);
      guide.xheightLabel.textContent = getNearestLabel(state.current.XHGT, xheightStops);

      guide.weightLabel.setAttribute("x", center);
      guide.weightLabel.setAttribute("dy", layout.labelLineHeight);
      guide.weightLabel.textContent = getNearestLabel(state.current.wght, weightStops);

      const labelBounds = guide.label.getBBox();
      guide.labelBox.setAttribute("x", labelBounds.x - letterLabelPaddingX);
      guide.labelBox.setAttribute("y", labelBounds.y - letterLabelPaddingY);
      guide.labelBox.setAttribute("width", labelBounds.width + letterLabelPaddingX * 2);
      guide.labelBox.setAttribute("height", labelBounds.height + letterLabelPaddingY * 2);
    });
  }

  function animate(now) {
    if (!isRunning) return;

    const elapsed = now - phaseStart;

    if (phase === "letter-switch-pause") {
      states.forEach((state) => applyState(state.el, state.current));
      updateGuides();

      if (elapsed >= letterSwitchPause) {
        sequenceIndex = (sequenceIndex + 1) % sequenceLetters.length;
        letters[0].textContent = sequenceLetters[sequenceIndex];
        sequenceChanges = 0;
        phase = "hold";
        phaseStart = now;
      }

      animationFrameId = requestAnimationFrame(animate);
      return;
    }

    if (phase === "hold") {
      states.forEach((state) => applyState(state.el, state.current));
      updateGuides();

      if (elapsed >= holdDuration) {
        const nextStates = isSequentialLetterDemo
          ? [makeDistinctState([states[0].current])]
          : makeStateSet(states.map((state) => state.current));

        states.forEach((state) => {
          state.from = { ...state.current };
          state.target = nextStates.shift();
        });

        phase = "transition";
        phaseStart = now;
      }

      animationFrameId = requestAnimationFrame(animate);
      return;
    }

    if (phase === "transition") {
      const progress = Math.min(elapsed / transitionDuration, 1);
      const eased = easeInOutCubic(progress);

      states.forEach((state) => {
        state.current = {
          wght: mix(state.from.wght, state.target.wght, eased),
          wdth: mix(state.from.wdth, state.target.wdth, eased),
          XHGT: mix(state.from.XHGT, state.target.XHGT, eased)
        };

        applyState(state.el, state.current);
      });

      updateGuides();

      if (progress >= 1) {
        if (isSequentialLetterDemo) {
          sequenceChanges += 1;

          if (sequenceChanges === 2) {
            phase = "letter-switch-pause";
            phaseStart = now;
            animationFrameId = requestAnimationFrame(animate);
            return;
          }
        }

        phase = "hold";
        phaseStart = now;
      }
    }

    animationFrameId = requestAnimationFrame(animate);
  }

  function start() {
    if (isRunning) return;

    isRunning = true;
    phaseStart = performance.now();
    animationFrameId = requestAnimationFrame(animate);
  }

  function stop() {
    isRunning = false;

    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
  }

  function refreshGuides() {
    syncGuideLabelFontSizes();
    states.forEach((state) => applyState(state.el, state.current));
    updateGuides();
  }

  function scheduleGuidesRefresh() {
    requestAnimationFrame(() => {
      requestAnimationFrame(refreshGuides);
    });
  }

  function initialize() {
    refreshGuides();

    const introSection = demo.closest("#intro") || demo;
    const introObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    introObserver.observe(introSection);
  }

  if (document.fonts?.ready) {
    document.fonts.ready.then(initialize);
    document.fonts.addEventListener?.("loadingdone", scheduleGuidesRefresh);
  } else {
    initialize();
  }

  window.addEventListener("load", scheduleGuidesRefresh, { once: true });

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(scheduleGuidesRefresh);
    resizeObserver.observe(svg);
  }

  return { element: demo, start, stop };
}

function createSvgEl(tag, classNames = []) {
  const el = document.createElementNS("http://www.w3.org/2000/svg", tag);
  classNames.forEach((name) => el.classList.add(name));
  return el;
}

function random(min, max) {
  return min + Math.random() * (max - min);
}

function shuffle(items) {
  const shuffled = [...items];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
}

function mix(a, b, t) {
  return a + (b - a) * t;
}

function easeInOutCubic(t) {
  return t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function getNearestLabel(value, stops) {
  let closest = stops[0];

  stops.forEach((stop) => {
    if (Math.abs(stop.value - value) < Math.abs(closest.value - value)) {
      closest = stop;
    }
  });

  return closest.label;
}


document.querySelectorAll("[data-intro-variable-demo]").forEach(demo => {
  initIntroVariableDemo(demo);
});

/*
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
Other Sections
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  
*/

  const featureDemos = [];

  function initTypeDemo(demo, settings) {
      const svg = demo.querySelector(".type-svg");
      const textArea = demo.querySelector(".type-text");

      const word = demo.querySelector(".word"); // SVG text, for existing demos
      const wordText = demo.querySelector(".word-text"); // HTML text, for xheight-caps demo

      const guides = demo.querySelector(".guides");
      const axisValue = demo.querySelector(".axis-value");
      const buttons = demo.querySelectorAll(".controls button");

      const xheightGuide = demo.querySelector(".xheight-guide");
      const baselineGuide = demo.querySelector(".baseline-guide");

      if (!axisValue || buttons.length === 0) return null;
      if (!word && !wordText) return null;

      const activeWord = wordText || word;

      const stops = settings.stops;

      let stopIndex = 0;
      let pauseUntil = 0;
      const pauseDuration = 700;

      let currentValue = stops[0];
      let isPausedByHover = false;
      let isRunning = false;
      let animationFrameId = null;

      const speed = settings.speed || 1;

      let guideLines = [];

      const yTop = 70;
      const yBottom = 340;

      function createWidthGuides() {
        if (!guides || !word) return;

        guides.innerHTML = "";
        guideLines = [];

        const text = word.textContent.trim();

        for (let i = 0; i < text.length; i++) {
          const line = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line"
          );

          line.setAttribute("y1", yTop);
          line.setAttribute("y2", yBottom);
          line.setAttribute("class", "guide-line");

          guides.appendChild(line);
          guideLines.push(line);
        }
      }

      function updateWidthGuides() {
        if (settings.axis !== "wdth") return;
        if (!word || !guides || guideLines.length === 0) return;

        const text = word.textContent.trim();

        for (let i = 0; i < text.length; i++) {
          if (!guideLines[i]) continue;

          const endPosition = word.getEndPositionOfChar(i);

          guideLines[i].setAttribute("x1", endPosition.x);
          guideLines[i].setAttribute("x2", endPosition.x);
        }
      }

      function updateXHeightGuides() {
        if (settings.axis !== "XHGT") return;
        if (!xheightGuide || !baselineGuide) return;

        const baselineY = settings.baselineY || 205;

        const minXHeight = Math.min(...settings.stops);
        const maxXHeight = Math.max(...settings.stops);

        const lowGuideY = settings.lowGuideY || 145;
        const tallGuideY = settings.tallGuideY || 85;

        const progress =
          (currentValue - minXHeight) / (maxXHeight - minXHeight);

        const xheightY =
          lowGuideY + (tallGuideY - lowGuideY) * progress;

        baselineGuide.setAttribute("y1", baselineY);
        baselineGuide.setAttribute("y2", baselineY);

        xheightGuide.setAttribute("y1", xheightY);
        xheightGuide.setAttribute("y2", xheightY);
      }

      function setAxisValue(value) {
        currentValue = value;

        const xhgt = settings.axis === "XHGT" ? currentValue : settings.xhgt;
        const wdth = settings.axis === "wdth" ? currentValue : settings.wdth;

        activeWord.style.fontVariationSettings = `
          "XHGT" ${xhgt},
          "wght" ${settings.wght},
          "wdth" ${wdth}
        `;

        axisValue.textContent = Math.round(currentValue);

        updateActiveButton();

        requestAnimationFrame(() => {
          updateWidthGuides();
          updateXHeightGuides();
        });
      }

      function updateActiveButton() {
        buttons.forEach(button => {
          button.classList.remove("active");

          const buttonValue = Number(button.dataset.value);

          if (Math.round(currentValue) === buttonValue) {
            button.classList.add("active");
          }
        });
      }

      function animate(timestamp) {
        if (!isRunning) return;

        if (!isPausedByHover) {
          if (timestamp < pauseUntil) {
            animationFrameId = requestAnimationFrame(animate);
            return;
          }

          const targetValue = stops[stopIndex];

          if (Math.abs(currentValue - targetValue) <= speed) {
            currentValue = targetValue;
            setAxisValue(currentValue);

            pauseUntil = timestamp + pauseDuration;

            stopIndex++;

            if (stopIndex >= stops.length) {
              stopIndex = 0;
            }
          } else {
            const moveDirection = currentValue < targetValue ? 1 : -1;
            currentValue += moveDirection * speed;
            setAxisValue(currentValue);
          }
        }

        animationFrameId = requestAnimationFrame(animate);
      }

      function start() {
        if (isRunning) return;

        isRunning = true;
        demo.classList.add("is-active-demo");
        animationFrameId = requestAnimationFrame(animate);
      }

      function stop() {
        isRunning = false;
        demo.classList.remove("is-active-demo");

        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
          animationFrameId = null;
        }
      }

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const value = Number(button.dataset.value);
      const currentStopIndex = stops.indexOf(value);

      stopIndex = currentStopIndex + 1;

      if (stopIndex >= stops.length || currentStopIndex === -1) {
        stopIndex = 0;
      }

      pauseUntil = performance.now() + pauseDuration;
      setAxisValue(value);
    });
  });

  [svg, textArea, ...buttons].filter(Boolean).forEach(el => {
    el.addEventListener("mouseenter", () => {
      isPausedByHover = true;
    });

    el.addEventListener("mouseleave", () => {
      isPausedByHover = false;
    });
  });

  document.fonts.ready.then(() => {
  createWidthGuides();
  setAxisValue(currentValue);
});

  return {
    element: demo,
    start,
    stop
  };
}



function initParagraphDemo(demo, settings) {
  const layers = [...demo.querySelectorAll(".paragraph-demo-layer")];
  const buttons = demo.querySelectorAll(".paragraph-controls button");

  if (layers.length === 0 || buttons.length === 0) return null;

  // function wrapText(el, spaceEvery, spaceClass) {
  function wrapText(el) {
    if (!el.dataset.originalText) {
      el.dataset.originalText = el.textContent;
    }

    const rawText = el.dataset.originalText
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    el.innerHTML = "";

    const words = rawText.split(" ");

    words.forEach((word, wordIndex) => {
      const wordUnit = document.createElement("span");
      wordUnit.className = "word-unit";

      [...word].forEach((char, charIndex) => {
        const letter = document.createElement("span");
        letter.className = "char-letter";
        letter.textContent = char;
        wordUnit.appendChild(letter);

        if (charIndex < word.length - 1) {
          const letterSpace = document.createElement("span");
          letterSpace.className = "letter-space";
          wordUnit.appendChild(letterSpace);
        }
      });

      el.appendChild(wordUnit);

      if (wordIndex < words.length - 1) {
        const wordSpace = document.createElement("span");
        wordSpace.className = "word-space";
        wordSpace.textContent = "\u00A0";

        // if ((wordIndex + 1) % spaceEvery === 0) {
        //   wordSpace.classList.add(spaceClass);
        // }
        wordSpace.classList.add(`word-space-${wordIndex + 1}`);
        el.appendChild(wordSpace);
      }
      
    });
  }

  layers.forEach((layer, index) => {
    const heading = layer.querySelector(".heading-demo-text");
    const paragraph = layer.querySelector(".paragraph-demo-text");
    const state = settings.states[index];

    if (!heading || !paragraph || !state) return;

    // wrapText(heading, 4, "word-space-4");
    // wrapText(paragraph, 8, "word-space-8");
    wrapText(heading);
    wrapText(paragraph);

   [heading, paragraph].forEach(el => {
      if (state.fontFamily) {
        el.style.fontFamily = state.fontFamily;
      }

      if (state.fontVariationSettings) {
        el.style.fontVariationSettings = state.fontVariationSettings;
      }
    });
  });

  const holdDuration = settings.holdDuration || 2400;

  let stateIndex = 0;
  let timeoutId = null;
  let isPausedByHover = false;
  let isRunning = false;

  function updateActiveButton() {
    buttons.forEach(button => {
      button.classList.toggle(
        "active",
        Number(button.dataset.state) === stateIndex
      );
    });
  }

  function showState(index) {
    if (!layers[index]) return;

    stateIndex = index;

    layers.forEach((layer, layerIndex) => {
      layer.classList.toggle("active", layerIndex === stateIndex);
    });

    updateActiveButton();
  }

  function clearAutoTimer() {
    if (timeoutId) {
      window.clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  function scheduleNext() {
    clearAutoTimer();

    if (!isRunning || isPausedByHover) return;

    timeoutId = window.setTimeout(() => {
      showState((stateIndex + 1) % layers.length);
      scheduleNext();
    }, holdDuration);
  }

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const nextIndex = Number(button.dataset.state);

      if (Number.isNaN(nextIndex) || !layers[nextIndex]) return;

      showState(nextIndex);
      scheduleNext();
    });
  });

  demo.addEventListener("mouseenter", () => {
    isPausedByHover = true;
    clearAutoTimer();
  });

  demo.addEventListener("mouseleave", () => {
    isPausedByHover = false;
    scheduleNext();
  });

  function start() {
    if (isRunning) return;

    isRunning = true;
    demo.classList.add("is-active-demo");
    showState(stateIndex);
    scheduleNext();
  }

  function stop() {
    isRunning = false;
    demo.classList.remove("is-active-demo");
    clearAutoTimer();
  }

  document.fonts.ready.then(() => {
    showState(0);
  });

  return {
    element: demo,
    start,
    stop
  };
}

function initSvgSlideshowDemo(demo, settings = {}) {
  const desktopSlides = [...demo.querySelectorAll(".svg-slideshow > .svg-slide")];
  const mobileSlides = [...demo.querySelectorAll(".svg-slideshow-mobile > .svg-slide")];
  const buttons = [...demo.querySelectorAll(".controls button")];
  const mobileQuery = window.matchMedia("(max-width: 640px)");

  if (!desktopSlides.length && !mobileSlides.length) return null;

  let currentIndex = 0;
  let intervalId = null;
  let isPausedByHover = false;

  const interval = settings.interval || 1400;

  function getSlides() {
    return mobileQuery.matches && mobileSlides.length ? mobileSlides : desktopSlides;
  }

  function showSlide(index) {
    const slides = getSlides();
    currentIndex = index % slides.length;

    [...desktopSlides, ...mobileSlides].forEach(slide => {
      slide.classList.remove("active");
    });

    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === currentIndex);
    });

    buttons.forEach((button, i) => {
      button.classList.toggle("active", i === currentIndex);
    });
  }

  function nextSlide() {
    const nextIndex = (currentIndex + 1) % getSlides().length;
    showSlide(nextIndex);
  }

  function start() {
    if (intervalId) return;

    demo.classList.add("is-active-demo");

    intervalId = window.setInterval(() => {
      if (!isPausedByHover) {
        nextSlide();
      }
    }, interval);
  }

  function stop() {
    demo.classList.remove("is-active-demo");

    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      showSlide(index);
    });
  });

  demo.addEventListener("mouseenter", () => {
    isPausedByHover = true;
  });

  demo.addEventListener("mouseleave", () => {
    isPausedByHover = false;
  });

  demo.addEventListener("focusin", () => {
    isPausedByHover = true;
  });

  demo.addEventListener("focusout", () => {
    isPausedByHover = false;
  });

  mobileQuery.addEventListener("change", () => showSlide(currentIndex));

  showSlide(0);

  return {
    element: demo,
    start,
    stop
  };
}


function initGlyphSlideshowDemo(demo, settings = {}) {
  const slides = [...demo.querySelectorAll(".glyph-slide")];
  const slideButtons = [...demo.querySelectorAll(".glyph-slideshow-controls > button")];

  if (!slides.length) return null;

  let currentIndex = 0;
  let intervalId = null;
  let toggleTimeoutId = null;
  let isPausedByHover = false;

  const interval = settings.interval || 2400;
  const toggleDelay = settings.toggleDelay || interval / 2;

  function setGlyphFeature(slide, state) {
    const display = slide.querySelector(".glyph-display");
    const toggleButtons = [...slide.querySelectorAll(".glyph-toggle button")];

    if (!display) return;

    const feature = slide.dataset.feature;

    display.classList.toggle("feature-off", state === "off");
    display.classList.toggle("feature-on", state === "on");

    display.style.fontFeatureSettings =
      state === "on" && feature
        ? `"${feature}" 1`
        : "normal";

    toggleButtons.forEach(button => {
      button.classList.toggle("active", button.dataset.state === state);
    });
  }

  function clearAutoToggle() {
    if (toggleTimeoutId) {
      window.clearTimeout(toggleTimeoutId);
      toggleTimeoutId = null;
    }
  }

  function scheduleAutoToggle() {
    clearAutoToggle();

    const activeSlide = slides[currentIndex];

    setGlyphFeature(activeSlide, "off");

    toggleTimeoutId = window.setTimeout(() => {
      if (!isPausedByHover) {
        setGlyphFeature(activeSlide, "on");
      }
    }, toggleDelay);
  }

  function showSlide(index) {
    currentIndex = index;

    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === currentIndex);

      if (i !== currentIndex) {
        setGlyphFeature(slide, "off");
      }
    });

    slideButtons.forEach((button, i) => {
      button.classList.toggle("active", i === currentIndex);
    });

    scheduleAutoToggle();
  }

  function nextSlide() {
    const nextIndex = (currentIndex + 1) % slides.length;
    showSlide(nextIndex);
  }

  slides.forEach(slide => {
    const toggleButtons = [...slide.querySelectorAll(".glyph-toggle button")];

    toggleButtons.forEach(button => {
      button.addEventListener("click", () => {
        clearAutoToggle();
        setGlyphFeature(slide, button.dataset.state);
      });
    });

    setGlyphFeature(slide, "off");
  });

  slideButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      showSlide(index);
    });
  });

  function start() {
    if (intervalId) return;

    demo.classList.add("is-active-demo");

    scheduleAutoToggle();

    intervalId = window.setInterval(() => {
      if (!isPausedByHover) {
        nextSlide();
      }
    }, interval);
  }

  function stop() {
    demo.classList.remove("is-active-demo");

    clearAutoToggle();

    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  demo.addEventListener("mouseenter", () => {
    isPausedByHover = true;
    clearAutoToggle();
  });

  demo.addEventListener("mouseleave", () => {
    isPausedByHover = false;
    scheduleAutoToggle();
  });

  demo.addEventListener("focusin", () => {
    isPausedByHover = true;
    clearAutoToggle();
  });

  demo.addEventListener("focusout", () => {
    isPausedByHover = false;
    scheduleAutoToggle();
  });

  showSlide(0);

  return {
    element: demo,
    start,
    stop
  };
}

  const widthDemo = document.querySelector(".width-demo");
  const xheightDemo = document.querySelector(".xheight-demo");

  if (widthDemo) {
    const demo = initTypeDemo(widthDemo, {
      axis: "wdth",
      stops: [75, 82, 100],
      speed: 0.4,
      xhgt: 353,
      wght: 400,
      wdth: 75
    });

    if (demo) featureDemos.push(demo);
  }

  if (xheightDemo) {
    const demo = initTypeDemo(xheightDemo, {
      axis: "XHGT",
      stops: [353, 574],
      speed: 4,
      xhgt: 353,
      wght: 400,
      wdth: 100,

      // adjust these if the guide line feels visually off
      baselineY: 205,
      lowGuideY: 100,
      tallGuideY: 35
    });

    if (demo) featureDemos.push(demo);
  }

  const demoObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const matchingDemo = featureDemos.find(
          demo => demo.element === entry.target
        );

        if (!matchingDemo) return;

        if (entry.isIntersecting) {
          matchingDemo.start();
        } else {
          matchingDemo.stop();
        }
      });
    },
    {
      threshold: 0.35,
      rootMargin: "-10% 0px -10% 0px"
    }
  );


const paragraphDemo = document.querySelector(".paragraph-demo");



if (paragraphDemo) {
  const demo = initParagraphDemo(paragraphDemo, {
    fadeDuration: 600,
    holdDuration: 2000,

    states: [
      {
        label: "Text",
        fontFamily: "'DunbarSeriesVF-mini'",
        fontVariationSettings: "var(--DunbarTextRegular_mini)"
      },
      {
        label: "Low",
        fontFamily: "'DunbarSeriesVF-mini'",
        fontVariationSettings: "var(--DunbarTextRegularUnadjusted_mini)"
      }
    ]
  });

  if (demo) featureDemos.push(demo);
}

const svgSlideshowDemo = document.querySelector(".svg-slideshow-demo");

if (svgSlideshowDemo) {
  const demo = initSvgSlideshowDemo(svgSlideshowDemo, {
    interval: 1400
  });

  if (demo) featureDemos.push(demo);
}


const xheightCapsDemo = document.querySelector(".xheight-caps-demo");

if (xheightCapsDemo) {
  const demo = initTypeDemo(xheightCapsDemo, {
    axis: "XHGT",
    stops: [574, 353],
    speed: 4,
    xhgt: 574,
    wght: 400,
    wdth: 100,

    baselineY: 205,
    lowGuideY: 145,
    tallGuideY: 85
  });

  if (demo) featureDemos.push(demo);
}

const glyphSlideshowDemo = document.querySelector(".glyph-slideshow-demo");

if (glyphSlideshowDemo) {
  const demo = initGlyphSlideshowDemo(glyphSlideshowDemo, {
    interval: 2600,
    toggleDelay: 1300
  });

  if (demo) featureDemos.push(demo);
}




  featureDemos.forEach(demo => {
    demoObserver.observe(demo.element);
  });

  window.featureAnimations = {
    stopAll() {
      featureDemos.forEach(demo => demo.stop());
    }
  };
  
  
});
